/* eslint-disable */
import qs from 'qs';
import {actions} from 'forms/rrf';
import {toast} from 'react-toastify';
import * as moment from 'moment';
import irelandApi from '../irelandApi';
import ToastMessage from '../components/common/toast-message';
import store from '../store';
import t from '../data/translations';

const assembleStaffMember = (payLoad) => {
  const mPayLoad = {...payLoad};
  mPayLoad.staff_permission_ids = [];
  Object.keys(payLoad.permission_ids).forEach((key) => {
    if (payLoad.permission_ids[key].checked === 'true') {
      mPayLoad.staff_permission_ids.push(key);
    }
  });
  delete mPayLoad.permission_ids;
  return mPayLoad;
};

export const getStaffByOutlet = (outletId) => (dispatch) => {
  dispatch({type: 'GET_STAFF_PENDING', payLoad: []});
  return irelandApi.get(`/api/my_staff_members/${outletId}/by_outlet`)
    .then((response) => {
      dispatch({type: 'GET_STAFF_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_STAFF_REJECTED', payLoad: error.data});
    });
};

export const resendInvitation = resendLink => (dispatch) => {
  dispatch({type: 'RESEND_STAFF_INVITATION_PENDING', payLoad: []});
  return irelandApi.get(resendLink)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Invitation has been resent successfully"/>);
      dispatch({type: 'RESEND_STAFF_INVITATION_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during resend invitation"/>);
      dispatch({type: 'RESEND_STAFF_INVITATION_REJECTED', payLoad: error.data});
    });
};

export const addStaff = outlet_id => (dispatch) => {
  dispatch({type: 'ADD_STAFF_PENDING'});
  return irelandApi.get('/api/my_staff_members/new')
    .then((response) => {
      if (outlet_id) {
        const permission_ids = {};
        const data = response.data.data;
        data.relationships.permissions.forEach((item) => {
          permission_ids[item.id] = {
            name: item.name,
          };
        });

        const staff_member = {
          title: '',
          first_name: '',
          last_name: '',
          mobile: '',
          email: '',
          outlet_id,
          agreed: false,
          is_champion: false,
          permission_ids
        };

        dispatch(actions.load('deep.staff_member', staff_member));
      }
      dispatch({type: 'ADD_STAFF_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'ADD_STAFF_REJECTED', payLoad: error.data});
    });
};

export const inviteStaff = (payload, outletId, onClose) => {
  store.dispatch({type: 'SAVE_STAFF_MEMBER_PENDING'});
  return irelandApi.post('/api/my_staff_members/invite', {my_staff_member: assembleStaffMember(payload)})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Invitation has been sent successfully"/>);
      store.dispatch(actions.reset('deep.staff_member'));
      store.dispatch(getStaffByOutlet(outletId));
      store.dispatch({type: 'SAVE_STAFF_MEMBER_FULFILLED', payLoad: response.data});
      onClose();
    })
    .catch((error) => {
      const { errors } = error.response.data;
      if (errors.outlet.length > 0) {
        toast.error(<ToastMessage iconStyle="error" message={errors.outlet[0]} />);
      } else {
        toast.error(<ToastMessage iconStyle="error" message="An error occured during invite" />);
      }
      store.dispatch({type: 'SAVE_STAFF_MEMBER_REJECTED'});
      store.dispatch(actions.resetValidity('deep.staff_member'));
      const data = {
        ...errors
      };
      return Promise.reject(data);
    });
};

export const getStaffMember = (getLink, row, status) => (dispatch) => {
  dispatch({type: 'GET_STAFF_MEMBER_PENDING', payLoad: []});
  return irelandApi.get(getLink)
    .then((response) => {
      const data = response.data.data;
      const permission_ids = {};
      if (data.attributes.permissions) {
        data.attributes.permissions.forEach((item) => {
          permission_ids[item.id] = {
            name: item.name,
            checked: `${item.checked}`
          };
        });
      }
      const staff_member = {
        title: data.attributes.title,
        first_name: data.attributes['first-name'],
        last_name: data.attributes['last-name'],
        mobile: data.attributes.mobile || '',
        email: data.attributes.email || '',
        outlet_id: `${data.attributes.outlet}`,
        is_champion: data.attributes['is-champion'] || false,
        original_is_champion: data.attributes['is-champion'] || false,
        permission_ids
      };

      dispatch(actions.load('deep.staff_member', staff_member));
      dispatch({
        type: 'SHOW_EDIT_STAFF', payLoad: data, saveLink: data.links.update, removeLink: data.links['remove-from-store'], show: row, status
      });
    })
    .catch((error) => {
      dispatch({type: 'GET_STAFF_MEMBER_REJECTED', payLoad: error.data});
    });
};

export const saveStaffMember = (payLoad, saveLink, outletId, onClose) => {
  store.dispatch({type: 'SAVE_STAFF_MEMBER_PENDING'});
  return irelandApi.patch(saveLink, {my_staff_member: assembleStaffMember(payLoad)})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Staff member has been saved successfully"/>);
      store.dispatch(actions.reset('deep.staff_member'));
      store.dispatch(getStaffByOutlet(outletId));
      store.dispatch({type: 'SAVE_STAFF_MEMBER_FULFILLED', payLoad: response.data});
      onClose();
    })
    .catch((error) => {
      store.dispatch({type: 'SAVE_STAFF_MEMBER_REJECTED'});
      store.dispatch(actions.resetValidity('deep.staff_member'));
      const { errors } = error.response.data;
      if (errors.outlet.length > 0) {
        toast.error(<ToastMessage iconStyle="error" message={errors.outlet[0]} />);
      } else {
        toast.error(<ToastMessage iconStyle="error" message="An error occured during save"/>);
      }
      const data = {
        ...errors
      };
      return Promise.reject(data);
    });
};

export const removeStaffMember = (removeLink, id, outletId) => (dispatch) => {
  dispatch({type: 'REMOVE_STAFF_MEMBER_PENDING'});
  return irelandApi.post(removeLink, {my_staff_member: {outlet_id: outletId}})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Staff member has been removed successfully"/>);
      dispatch({type: 'REMOVE_STAFF_MEMBER_FULFILLED', payLoad: response.data, id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during remove"/>);
      dispatch({type: 'REMOVE_STAFF_MEMBER_REJECTED', payLoad: error.data});
    });
};

export const getSettings = () => (dispatch) => {
  dispatch({
    type: 'GET_SETTINGS_PENDING',
    payLoad: []
  });

  return irelandApi.get('/api/admin/settings')
    .then((response) => {
      const attributes = response.data.data.attributes;
      const settings = {
        overarching_threshold: attributes['overarching-threshold'],
        scan_override_threshold: attributes['scan-override-threshold'],
        game_expiry_days: attributes['game-expiry-days'],
        achievement_target: attributes['achievement-target'],
        scan_target: attributes['scan-target']
      };

      dispatch(actions.load('deep.admin_settings', settings));
      dispatch({ type: 'GET_SETTINGS_FULFILLED', payLoad: settings });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_SETTINGS_REJECTED',
        payLoad: error.data
      });
    });
};

export const saveSettings = (payLoad) => {
  const data = {
    settings: {
      overarching_threshold: +payLoad.overarching_threshold,
      scan_override_threshold: +payLoad.scan_override_threshold,
      game_expiry_days: payLoad.game_expiry_days,
      achievement_target: +payLoad.achievement_target,
      scan_target: +payLoad.scan_target,
    }
  };

  return irelandApi.patch('/api/admin/settings', { ...data })
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message={t('settings.saved.success')}/>);
      store.dispatch(actions.setValidity('deep.admin_settings', false));
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message={t('settings.saved.error')}/>);

      const data = {
        ...error.response.data.errors
      };

      return Promise.reject(data);
    });
};

export const initPersonalRewardsForm = () => (dispatch) => {
  dispatch({
    type: 'GET_PERSONAL_REWARDS_PENDING',
    payLoad: []
  });
  return irelandApi.get('/api/personal_rewards')
    .then((response) => {
      const attributes = response.data.data.attributes;
      if (attributes['ppc-status'] === 'opted_in') {
        const data = {
          title: attributes.title,
          first_name: attributes['first-name'],
          last_name: attributes['last-name'],
          date_of_birth: moment(attributes['date-of-birth'], 'YYYY-MM-DD').format('DD/MM/YYYY'),
          address_1: attributes['address-1'],
          address_2: attributes['address-2'],
          town: attributes.town,
          county: attributes.county,
          eircode: attributes.eircode,
          store_name: attributes['store-name'],
          email: attributes.email,
          mobile: attributes.mobile
        };
        dispatch(actions.load('deep.personal_rewards', data));
      }
      dispatch({
        type: 'GET_PERSONAL_REWARDS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_PERSONAL_REWARDS_REJECTED',
        payLoad: error.data
      });
    });
};

export const savePersonalRewards = (payLoad) => {
  return irelandApi.post('api/ppc_users', { ppc_user: payLoad })
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Personal rewards settings saved successfully" />);
      store.dispatch({ type: 'TOGGLE_PERSONAL_REWARDS_SETTINGS_DIALOG', payLoad: false });
    }).catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save personal rewards settings" />);
      store.dispatch(actions.resetValidity('deep.personal_rewards'));

      const data = {
        ...error.response.data.errors
      };

      return Promise.reject(data);
    });
};
